export default __webpack_public_path__ + "static/media/afterparty-event-hero-banner.2bd9cc28.png";